import React, { Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import { Skeleton } from '@/components/ui/skeleton'

const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

function AuthLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50">
      <Skeleton className="h-96 w-full max-w-md rounded-xl" />
    </div>
  )
}

function App() {
  return (
    <HashRouter>
      <Suspense fallback={<AuthLoader />}>
        <Routes>
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route path="/*" element={<DefaultLayout />} />
          <Route exact path="/404" element={<Page404 />} />
          <Route exact path="/500" element={<Page500 />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </Suspense>
    </HashRouter>
  )
}

export default App
